import React from 'react';
import classnames from "classnames";
import {FormattedMessage} from "react-intl";
import ReactSVG from "react-svg";

function SummaryPageSkeleton() {
  const pageCssBEM = "summaryPage";
  const classes = classnames(pageCssBEM, {
    [`${pageCssBEM}--skeleton`]: true
  });

  return (
    <div className={classes}>
      <div className="sidebar sidebar--summary">
        <div className="sidebar__logo">
          <ReactSVG src="/classpath/assets/images/central-logo.svg"/>
        </div>
        <div className="sidebar__products">
          <div className="sidebar-skeleton-product"><span /></div>
          <div className="sidebar-skeleton-product"><span /></div>
          <div className="sidebar-skeleton-product"><span /></div>
          <div className="sidebar-skeleton-product"><span /></div>
          <div className="sidebar-skeleton-product"><span /></div>
        </div>
      </div>
      <div className={ `${ pageCssBEM }__products` }>
        <div className="swiper-container">
          <div className="swiper-wrapper">
            <div className="welcome-slide swiper-slide">
              <div>
                <h1><FormattedMessage id="summary.welcome"/></h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SummaryPageSkeleton;

